import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-app-store-dark-icon',
  templateUrl: 'app-store-dark.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppStoreDarkIcon { }
